import { MAP_TYPES } from '@deck.gl/carto';
 
const LANE_CLOSURE_SAFETY_SEGMENT_SOURCE_ID = 'laneClosureSafetySegmentSource';
 
const source = {
  id: LANE_CLOSURE_SAFETY_SEGMENT_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'lane_closure_safety_segment',
};
 
export default source;
 